var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSwitchTeacher = function SvgIconSwitchTeacher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.5 11.78c1.69 0 3.009 1.29 3 2.82-.003.47-.422.901-1 .901h-7c-.578 0-.997-.432-1-.9-.009-1.53 1.31-2.822 3-2.822q.044 0 .074.01c.442.136.918.227 1.426.227s.984-.091 1.426-.227a.3.3 0 0 1 .074-.01ZM5 5.167c1.408 0 2.5 1.071 2.5 2.333S6.408 9.835 5 9.835 2.5 8.763 2.5 7.501 3.592 5.168 5 5.168Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.832.005A4 4 0 0 1 18.626 4v4.54l-.005.206a4 4 0 0 1-3.789 3.79l-.206.004h-4.43a8 8 0 0 0 .177-1h4.253a3 3 0 0 0 3-3V4a3 3 0 0 0-2.846-2.996L14.626 1h-6.47a3 3 0 0 0-2.833 2.018 8 8 0 0 0-.95-.32A4 4 0 0 1 7.95.004L8.156 0h6.47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.667 11.668a1 1 0 0 1 1-1h.666a1 1 0 0 1 1 1v.333h-2.667z"
  })));
};
export default SvgIconSwitchTeacher;